// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vy5A","col":"styles_col__3VnyV"};